import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Zoom } from 'swiper/modules';
import DeleteImageButton from '../buttons/DeleteImageButton';

const Images = ({ images, readOnly, loading, onDelete, onClick, fullSize }) => {
  return (
    <Swiper
      style={{
        '--swiper-navigation-color': '#ebedef',
        '--swiper-pagination-color': '#ebedef',
      }}
      slidesPerView={1}
      zoom={true}
      loop={images.length !== 1}
      navigation={images.length !== 1}
      modules={[Navigation, Zoom]}
    >
      {images?.map((image, i) => (
        <SwiperSlide key={i}>
          <Image image={image} onClick={onClick} fullSize={fullSize} />
          {!readOnly && <DeleteImageButton loading={loading} onClick={() => onDelete(image)} />}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const Image = ({ onClick, image, fullSize }) => (
  <div className={`swiper-zoom-container cursor-pointer`} onClick={onClick}>
    <img className={`w-full ${fullSize ? ' h-full object-fill' : 'h-72 object-contain'}`} src={image.url} alt="visit" />
  </div>
);

export default Images;
